import { formatPrice } from './format';

export const currencies = [
  {
    value: 'usd',
    label: 'USD - Americký dolar',
    unicode: '\u0024',
    position: 'prefix',
  },
  {
    value: 'gbp',
    label: 'GBP - Britská libra',
    unicode: '\u00A3',
    position: 'prefix',
  },
  {
    value: 'eur',
    label: 'EUR - Euro',
    unicode: '\u20AC',
    position: 'suffix',
  },
  {
    value: 'czk',
    label: 'CZK - Česká koruna',
    unicode: 'Kč',
    position: 'suffix',
  },
  {
    value: 'nok',
    label: 'NOK - Norská koruna',
    unicode: 'kr',
    position: 'suffix',
  },
  {
    value: 'sek',
    label: 'SEK - Švédská koruna',
    unicode: 'kr',
    position: 'suffix',
  },
  {
    value: 'aud',
    label: 'AUD - Australský dolar',
    unicode: '$',
    position: 'prefix',
  },
  {
    value: 'huf',
    label: 'HUF - Maďarský forint',
    unicode: 'Ft',
    position: 'suffix',
  },
  {
    value: 'inr',
    label: 'INR - Indická rupie',
    unicode: '₹',
    position: 'prefix',
  },
  {
    value: 'dkk',
    label: 'DKK - Dánská koruna',
    unicode: 'kr',
    position: 'suffix',
  },
  {
    value: 'pln',
    label: 'PLN - Polský zlotý',
    unicode: 'zł',
    position: 'suffix',
  },
  {
    value: 'try',
    label: 'TRY - Turecká lira',
    unicode: '₺',
    position: 'suffix',
  },
  {
    value: 'bgn',
    label: 'BGN - Bulharský lev',
    unicode: 'лв',
    position: 'suffix',
  },
  {
    value: 'chf',
    label: 'CHF - Švýcarský frank',
    unicode: 'CHF',
    position: 'prefix',
  },
  {
    value: 'ron',
    label: 'RON - Rumunský leu',
    unicode: 'lei',
    position: 'suffix',
  },
  {
    value: 'jpy',
    label: 'JPY - Japonský jen',
    unicode: '\u00A5',
    position: 'suffix',
  },
  {
    value: 'cad',
    label: 'CAD - Kanadský dolar',
    unicode: '$',
    position: 'prefix',
  },
  {
    value: 'nzd',
    label: 'NZD - Novozélandský dolar',
    unicode: '$',
    position: 'prefix',
  },
  {
    value: 'sgd',
    label: 'SGD - Singapurský dolar',
    unicode: '$',
    position: 'prefix',
  },
  {
    value: 'brl',
    label: 'BRL - Brazílský real',
    unicode: 'R$',
    position: 'prefix',
  },
  {
    value: 'cny',
    label: 'CNY - Čínský jüan',
    unicode: '\u00A5',
    position: 'prefix',
  },
  {
    value: 'myr',
    label: 'MYR - Malajsijský ringgit',
    unicode: 'RM',
    position: 'prefix',
  },
  {
    value: 'idr',
    label: 'IDR - Indonéská rupie',
    unicode: 'Rp',
    position: 'suffix',
  },
  {
    value: 'php',
    label: 'PHP - Filipínské peso',
    unicode: '₱',
    position: 'prefix',
  },
  {
    value: 'hkd',
    label: 'HKD - Hongkongský dolar',
    unicode: '$',
    position: 'suffix',
  },
  {
    value: 'isk',
    label: 'ISK - Islandská koruna',
    unicode: 'kr',
    position: 'suffix',
  },
  {
    value: 'ils',
    label: 'ILS - Izraelský nový šekel',
    unicode: '₪',
    position: 'suffix',
  },
  {
    value: 'zar',
    label: 'ZAR - Jihoafrický rand',
    unicode: 'R',
    position: 'prefix',
  },
  {
    value: 'krw',
    label: 'KRW - JihoKorejský won',
    unicode: '₩',
    position: 'suffix',
  },
  {
    value: 'mxn',
    label: 'MXN - Mexické peso',
    unicode: '$',
    position: 'prefix',
  },
  {
    value: 'xdr',
    label: 'XDR - Special Drawing Rights',
    unicode: 'SDR',
    position: 'suffix',
  },
  {
    value: 'thb',
    label: 'THB - Thajský baht',
    unicode: '฿',
    position: 'prefix',
  },
];

export const getCurrencyName = (val: string | null | undefined) => {
  if (!val || val === 'other') {
    return '';
  }

  const currency = currencies.find((c) => c.value.toLowerCase() === val.toLowerCase());

  if (!currency) {
    return 'Neznámá měna';
  }

  return currency.unicode ?? '';
};

export const getPriceWithCurrencyString = (price: number | string, currencyCode: string | null | undefined) => {
  // round price to 2 decimal places
  const priceRounded = Math.round(Number(price) * 100) / 100;
  const priceFormatted = formatPrice(priceRounded);

  if (!currencyCode || currencyCode === 'other') {
    return `${priceFormatted}`;
  }

  const currency = currencies.find((c) => c.value.toLowerCase() === currencyCode.toLowerCase());

  if (!currency) {
    return `${priceFormatted} Neznámé měny`;
  }

  let builder = [priceFormatted, currency.unicode];

  if (currency.position === 'prefix') {
    builder = builder.reverse();
  }

  return builder.join(' ');
};
